import { useLanguage } from '@/i18n/LanguageContext';
import { motion } from 'framer-motion';
import { Briefcase, Users, GraduationCap, Globe, Plane, Handshake } from 'lucide-react';

const expertiseItems = [
  { icon: Briefcase, title: { he: 'ייעוץ אסטרטגי ופיננסי', ar: 'استشارات استراتيجية ومالية', en: 'Strategic & Financial Consulting' }, desc: { he: 'ליווי וייעוץ להנהלות בכירות, קבלת החלטות מורכבות והובלת מהלכים אסטרטגיים', ar: 'مرافقة واستشارة الإدارات العليا، اتخاذ القرارات المعقدة وقيادة المسارات الاستراتيجية', en: 'Advising and accompanying senior management, navigating complex decisions, leading strategic initiatives' } },
  { icon: Users, title: { he: 'פיתוח עסקי ומיתוג', ar: 'تطوير أعمال وتسويق', en: 'Business Development & Branding' }, desc: { he: 'יח"ץ, מיתוג ובניית ממשקי עבודה אפקטיביים בין מגזרים', ar: 'علاقات عامة وعلامة تجارية وبناء واجهات عمل فعّالة بين القطاعات', en: 'PR, branding, and building effective interfaces between sectors' } },
  { icon: GraduationCap, title: { he: 'הנגשת השכלה גבוהה', ar: 'تسهيل التعليم العالي', en: 'Higher Education Access' }, desc: { he: 'הרחבת ההשתלבות של החברה הערבית בשוק העבודה הישראלי', ar: 'توسيع اندماج المجتمع العربي في سوق العمل الإسرائيلي', en: 'Expanding Arab society integration in the Israeli labor market' } },
  { icon: Globe, title: { he: 'גישור בין-תרבותי', ar: 'وساطة بين الثقافات', en: 'Cross-Cultural Mediation' }, desc: { he: 'בניית גשרים בין החברה הערבית והיהודית, שיח גיוון וייצוג', ar: 'بناء جسور بين المجتمع العربي واليهودي، حوار التنوع والتمثيل', en: 'Building bridges between Arab and Jewish societies, promoting diversity dialogue' } },
  { icon: Plane, title: { he: 'תעופה', ar: 'طيران', en: 'Aviation' }, desc: { he: 'מערך הטסת עולי רגל — מעל 30,000 נוסעים בשנה, קווי תעופה אזוריים', ar: 'نقل الحجاج — أكثر من 30,000 مسافر سنويًا، خطوط طيران إقليمية', en: 'Pilgrimage flight operations — over 30,000 passengers/year, regional airline routes' } },
  { icon: Handshake, title: { he: 'חוסן קהילתי', ar: 'صمود مجتمعي', en: 'Community Resilience' }, desc: { he: 'תוכניות ללימוד עברית, העצמה קהילתית וצמצום פערים', ar: 'برامج تعلم العبرية، تمكين مجتمعي وسد الفجوات', en: 'Hebrew learning programs, community empowerment, and bridging gaps' } },
];

const ExpertiseSection = () => {
  const { lang, t } = useLanguage();

  return (
    <section className="py-14">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="text-2xl md:text-3xl font-bold mb-3">{t('section.expertise_title')}</h2>
          <div className="w-16 h-1 bg-primary mx-auto rounded-full" />
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          {expertiseItems.map(({ icon: Icon, title, desc }, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="group p-5 rounded-xl bg-card border border-border/50 hover:border-primary/30 transition-all hover:shadow-[var(--shadow-gold)]"
            >
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                <Icon className="w-5 h-5 text-primary" />
              </div>
              <h3 className="text-base font-semibold mb-2">{title[lang]}</h3>
              <p className="text-muted-foreground text-xs leading-relaxed">{desc[lang]}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
